/*global define, require*/
/*jshint devel:true*/

/**
 * Component Post Loader
 *
 * Portal has the option to postload component content.
 * On page load, this script will go through the DOM and find any components that require content to be rendered
 * after postload.
 *
 * Example:
 * When a component is configured to be post loaded, it printed like this on the page:
 * <div class="postloadfragment" data-postLoad="d25aaa014c570410VgnVCM1000001760740aRCRD"></div> *
 * We then do an ajax call to pull the content of component ID: d25aaa014c570410VgnVCM1000001760740aRCRD and then place
 * it in the DIV.
 *
 * Sequences and Threading:
 * Every component that requires postloading will have 2 additonal data attributes:
 * (a) data-postloadsequence
 * (b) data-postloadthread
 * This script will gather all components in sequence (0..1..2..3) and every sequence will have x amounts of threads
 * (async ajax calls)
 *
 * Example:
 *		Components	Sequences	Thread
 *		1			0			0
 *		2			0			0
 *		3			1			0
 *		4			1			1
 *		5			1			1
 *
 * Sequence 0 will run first, with only one thread that will retrieve components #1 and #2
 * Sequence 1 will run right after with 2 threads, first one gets components #3 and the other gets #4 and #5
 * So there will 3 ajax calls to get all 5 components.
 *
 *
 *
 */
define(
	'componentPostLoader',[
		'underscore',
		'jquery',
		'ModuleManager'
	],
	function (_, $, ModuleManager) {
		'use strict';

		return {
			/**
			* Array of all components to postload, in order of sequence and threads
			*/
			postloadComponents: [],
			/**
			* Array to hold each sequence and its thread count, used to know if we can move onto next sequence
			*/
			sequenceThreadCount: [],
			/**
			* Class name of elements that require post loading
			*/
			divClassName: 'postloadfragment',
			/**
			* Class name of element after postload is complete
			*/
			divClassPostLoadComplete: 'postload-complete',
			/**
			* Data attribute containing the component ID to retrieve
			*/
			divDataAtttribute: 'postload',
			/**
			* Data attribute containing the sequence #
			*/
			divDataAtttributeSequence: 'postloadsequence',
			/**
			* Data attribute containing the thread #
			*/
			divDataAtttributeThread: 'postloadthread',
			/**
			* Data attribute containing the url to use for the component ID to retrieve
			*/
			divDataUrlAtttribute: 'url',
			/*
			* The event trigger of when the post loading is complete
			*/
			triggerPostLoadingFinish: 'ComponentPostLoaderFinish',
			/**
			* Ajax settings
			*/
			ajaxTimeout: 100000,
			ajaxRetryLimit: 5,
            ajaxHelper: {},

			/**
			* Get all elements that require post loading
			* Element must contained divClassName and divDataAttribute (that isnt empty).
			* @return (jQuery)
			*/
			getPostLoadComponents: function() {
				var self = this;
				return $('.'+self.divClassName).filter('[data-'+self.divDataAtttribute+'!=""]');
			},
			/**
			* Get the dom element by postload component id
			* @param (String) id The component ID to retrieve
			* @return (jQuery)
			*/
			getDomElementByComponentId: function(id) {
				var self = this;
				return self.getPostLoadComponents().filter('[data-'+self.divDataAtttribute+'="'+id+'"]');
			},
			/**
			* Get the url used by the first post loader and use it, if it doesn't exists use the window.location.href
			* @param (jQuery) componentsToPostLoad the list of components to postload
			* @return (String)
			*/
			getAjaxUrl: function(component) {
				var url = window.location.href.split('#')[0];

				if (typeof component.url !== "undefined") {
					url = component.url;
				}

				return url;
			},
			/*
			* This is called on a successful ajax call. We determine if we need to move onto next sequence.
			* @param sequence
			* @param thread
			*/
            updateSequenceCount: function (sequence) {
                var self = this,
                    sequenceThreadLength = 0;
                try {
                    sequenceThreadLength = Object.keys(self.postloadComponents[sequence]).length;
                } catch (e) {
                    // Added this to handle IE8 issue with Object.keys
                    for (var prop in self.postloadComponents[sequence]) {
                        if (self.postloadComponents[sequence].hasOwnProperty(prop)) {
                            sequenceThreadLength = sequenceThreadLength + 1;
                        }
                    }
                }

                if (typeof self.sequenceThreadCount[sequence] === "undefined") {
                    self.sequenceThreadCount[sequence] = 0;
                }

                self.sequenceThreadCount[sequence]++;

                if (sequenceThreadLength === self.sequenceThreadCount[sequence]) {
                    self.retrieveComponentsBySequence(sequence + 1);
                }

            },
			/*
			* Loop through the components to postload, ordered by sequence and retrieve the data from portal
			* @param seqNumber the sequene # to retrieve via ajax
			*/
            retrieveComponentsBySequence: function (seqNumber) {
                var self = this,
                    components = self.postloadComponents[seqNumber];

                // we have ended the sequences
                if (typeof components === "undefined") {
                    console.timeEnd('componentPostLoader');
                    $(window).trigger(self.triggerPostLoadingFinish);
                    return false;
                }

                // loop through all threads in this sequence
                _.each(components, function (componentValue, componentKey) {

                    var listComponentIds = [],
                        ajaxUrl;

                    // loop through all elements in this thread
                    _.each(componentValue, function (componentThreadValue) {
                        listComponentIds.push(componentThreadValue.componentId);

                        // the ajax url is based on a URL attribute if exists on the components
                        if (typeof ajaxUrl === "undefined") {
                            ajaxUrl = self.getAjaxUrl(componentThreadValue);
                        }
                    });

                    var xhrParams = {
                        url: ajaxUrl,
                        dataType: 'jsonp',
                        data: {
                            'targetedComponentIdList': listComponentIds,
                            'postLoadRequest': true,
                            'sequence': seqNumber,
                            'thread': componentKey
                        },
                        traditional: true,
                        tryCount: 0,
                        timeout: self.ajaxTimeout
                    };
                    var xhrDone = function (jsonResponse) {

                        var ajaxSelf = this;

                        var bFoundExceptionCheck = function (dataReturn, key, ajaxSelf) {
                            // PeterM - BAU-810 Prod Major

                            var bFoundException = false;

                            // Service Selector
                            if (key === "a9e4425b98d61410VgnVCM1000001760740aRCRD") {
                                if (/billingSummary/.test(dataReturn)) {
                                    bFoundException = true;
                                }
                                // Billing Summary
                            } else if (key === "1bcf3e59f49b1410VgnVCM1000001760740aRCRD") {
                                if (/NumberFormatException/.test(dataReturn)) {
                                    bFoundException = true;
                                }
                            } else if (/Neither BindingResult nor plain target object for bean name/.test(dataReturn) &&
                                /accountLogin/.test(dataReturn)) {
                                bFoundException = true;
                            }

                            if (bFoundException) {
                                console.debug("componentPostLoader.retrieveComponentsBySequence(): Java exception found, requesting component again.", "component id:", key, "try count:", ajaxSelf.tryCount);
                            }

                            return bFoundException;
                        };

                        var redirectIfSessionHasExpired = function (dataReturn) {
                            // If responce is a valid JSON object and find the redirection
                            // attributes, then we go ahead, otherwise we continue we just
                            // dumping the html content in the respective component.
                            try {
                                var jsonObj = $.parseJSON(dataReturn);
                                if (!!jsonObj.success) {
                                    if (jsonObj.data && jsonObj.data.redirectUrl) {
                                        window.location.href = jsonObj.data.redirectUrl;
                                    }
                                    return;
                                }
                            } catch (e) {
                                // Pav
                                // FIXME Below is a dummy code to bypass Sonar Quality Gates which requires something in catch condition.
                                // This really need to be fixed!
                                e = null;
                            }
                        };

                        var processComponents = function (component) {

                            var key = _.keys(component).pop();
                            var dataReturn = component[key];

                            var $componentElem = self.getDomElementByComponentId(key);
                            if (!$componentElem.length) {
                                return;
                            }

                            // PeterM - BAU-810 Prod Major
                            if (bFoundExceptionCheck(dataReturn, key, ajaxSelf)) {
                                ajaxSelf.tryCount++;
                                if (ajaxSelf.tryCount <= self.ajaxRetryLimit) {
                                    $.ajax(ajaxSelf)
                                        .done(self.ajaxHelper.success)
                                        .fail(self.ajaxHelper.error);
                                }
                                return;
                            }

                            // Detect if we have an expired session and need to do a redirection
                            redirectIfSessionHasExpired(dataReturn);

                            $componentElem
                                .removeClass(self.divClassName)
                                .addClass(self.divClassPostLoadComplete);

                            try {
                                $componentElem.html(dataReturn);
                            } catch (e) {
                                console.error("componentPostLoader.retrieveComponentsBySequence", key, e);
                            }

                            // TODO: any postload JS triggering after dom update?
                            // Eg. foundation, backbone controllers?

                            var moduleContainer = ModuleManager.getModuleContainers($componentElem);

                            if (moduleContainer.length > 0) {
                                ModuleManager.initialiseModule(moduleContainer.eq(0));
                            }

                        };

                        // replace dom element with content from ajax response
                        _(jsonResponse.data).map(processComponents).value();

                        self.updateSequenceCount(seqNumber, componentKey);
                    };

                    var xhrFail = function (xhr, textStatus, errorThrown) {
                        console.error("componentPostLoader error: ", xhr, textStatus, errorThrown);

                        if (textStatus === 'timeout') {
                            this.tryCount++;
                            if (this.tryCount <= self.ajaxRetryLimit) {
                                $.ajax(this)
                                    .done(self.ajaxHelper.success)
                                    .fail(self.ajaxHelper.error);
                                return;
                            }
                            return;
                        }
                    };


                    var key = listComponentIds.join('.');

                    // cMap - is the map of components used on the page
                    // if it's not defined the framework will gather the data from DOM


                    var componentsMapWithXhrPromises = (window.cMap && cMap.xhrData && cMap.xhrData[key] && cMap.xhrData[key].listComponentIds)
                        ? cMap.xhrData[key].listComponentIds
                        : [];

                    if (_.isEqual(componentsMapWithXhrPromises.sort(), listComponentIds.sort())) {
                        var xhr = cMap.xhrData[key].xhr;
                    } else {
                        var xhr = $.ajax(xhrParams);
                    }

                    self.ajaxHelper = {
                        success: xhrDone,
                        error: xhrFail
                    };

                    xhr.done(xhrDone);
                    xhr.fail(xhrFail);

                });

            },

			/**
			* Loop through the DOM and get all components we need to post load
			* Generates an array of components to postload, ordered by sequences and then threads
			* @returns {Array}
			*/
			getComponentsToRetrieve: function() {
				var self = this,
					componentsToPostLoad = self.getPostLoadComponents(),
					returnPostLoadComponents = [];

				$(componentsToPostLoad).each(function(){
					var thisElem = $(this),
						thisElemComponentId = thisElem.data(self.divDataAtttribute),
						thisElemSeq = thisElem.data(self.divDataAtttributeSequence) || 0,
						thisElemThread = thisElem.data(self.divDataAtttributeThread) || 0,
						thisElemUrl = thisElem.data(self.divDataUrlAtttribute),
						thisElemArray = {
							seq: thisElemSeq,
							thread: thisElemThread,
							componentId: thisElemComponentId,
							url: thisElemUrl
						};

						returnPostLoadComponents.push(thisElemArray);
				});

				/*
				* Underscore function to extend _.groupBy to allow multiple indexes
				* http://stackoverflow.com/a/13869056
				*/
				_.groupByMulti = function (obj, values, context) {
					if (!values.length) {
						return obj;
					}

					var byFirst = _.groupBy(obj, values[0], context),
						rest = values.slice(1);

					for (var prop in byFirst) {
						byFirst[prop] = _.groupByMulti(byFirst[prop], rest, context);
					}

					return byFirst;
				};

				returnPostLoadComponents = _.groupByMulti(returnPostLoadComponents, ['seq', 'thread']);

				console.log("componentPostLoader.getComponentsToRetrieve(): returnPostLoadComponents", returnPostLoadComponents);

				return returnPostLoadComponents;
			},

            portletPartials: {

                inProgressCSSClass: "portletPartialLoadingInProgress",
                loadedCSSClass:  "portletPartialLoaded",
                partialLoadedEvent: "portletPartialLoaded",

                getList: function () {
                    var partials = $(document)
                        .find('.postloadPortletPartial')
                        .not("." + this.inProgressCSSClass)
                        .not("." + this.loadedCSSClass);
                    var list = _.map(partials, function (partial, i) {
                        return {
                            id: $(partial).attr('id'),
                            fetchUrl: $(partial).data('url'),
                            resultTarget: '#' + $(partial).attr('id'),
                            callback: $(partial).data('callback')
                        };
                    });
                    return list;
                },

                fetchData: function (partialsList) {
                    var self = this;
                    _.map(partialsList, function (partial, i) {
                        if (!partial.fetchUrl) {
                            console.error("Fetch url for portlet partial seem to be invalid", partial);
                            return;
                        }
                        $('#' + partial.id).addClass(self.inProgressCSSClass);
                        partialsList[i].xhrPromise = $.ajax({
                            url: partial.fetchUrl,
                            dataType: 'json'
                        });
                        partialsList[i].xhrPromise
                            .done(function (response) {
                                if (response.data && !_.isUndefined(response.data.html)) {
                                    $(partial.resultTarget).html(response.data.html);
                                    $('#' + partial.id).addClass(self.loadedCSSClass);
                                } else {
                                    console.error("Invalid response structure", response);
                                }
                            })
                            .fail(function (response) {
                                console.error("Failed to postload portlet partial data", response);
                            })
                            .always(function () {
                                $('#' + partial.id).removeClass(self.inProgressCSSClass);
                                delete partialsList[i].xhrPromise;
                                $(window).trigger(self.partialLoadedEvent, partial);
                            });
                    });

                    $(window).on(self.partialLoadedEvent, function (partial) {
                        if (typeof self.handlers[partial.callback] === "function") {
                            self.handlers[partial.callback]();
                        }
                        _.delay(function(text) {
                            $(".optusTip").optusTip("right");
                        }, 250);
                    });
                },

                handlers: {
                    handleContractEndDate: function () {
                        var serviceContractInformation = $('#serviceContractInformation').text().trim();
                        if (serviceContractInformation.length === 0) {
                            $("#serviceContractInformationContainer").hide();
                        }
                    }
                }
            },

			init: function() {
				var self = this;

				$(function () {
					console.time('componentPostLoader');

					// get list of all components
					self.postloadComponents = self.getComponentsToRetrieve();
					// start by first sequence
					self.retrieveComponentsBySequence(0);

                    var partialsList = self.portletPartials.getList();
                    self.portletPartials.fetchData(partialsList);

					// Allow other frameworks to trigger portlet loading.
					$(document).on('initPortlets.lux', function () {
						var partialsList = self.portletPartials.getList();
						self.portletPartials.fetchData(partialsList);
					});
				});

				return self;
			}

		};
	}
);

